// extracted by mini-css-extract-plugin
module.exports = {"bundles":"Bundle_bundles__Sm9x6"};